import React from "react";
import { Alert, Input, Spinner, Table } from "reactstrap";
import {
  fmtHoverDateTime,
  fmtRelativeTime,
  STORE_DASHBOARD_FILTER_INPUT_CLASS,
} from "./storeSalesDashboardHelpers";

const StoreSalesDashboardNotificationsSection = ({
  notificationsLoading,
  notificationsError,
  notificationNameFilter,
  setNotificationNameFilter,
  notificationTemplateFilter,
  setNotificationTemplateFilter,
  notificationStatusFilter,
  setNotificationStatusFilter,
  notificationTemplateOptions,
  notificationStatusOptions,
  filteredNotifications,
  handleNotificationsSort,
  renderNotificationSortIcon,
}) => {
  return (
    <>
      <div className="store-notifications-filter-row mb-3">
        <Input
          bsSize="sm"
          value={notificationNameFilter}
          onChange={(e) => setNotificationNameFilter(e.target.value)}
          placeholder="Filter by name"
          className={STORE_DASHBOARD_FILTER_INPUT_CLASS}
        />
        <Input
          type="select"
          bsSize="sm"
          value={notificationTemplateFilter}
          onChange={(e) => setNotificationTemplateFilter(e.target.value)}
          className={STORE_DASHBOARD_FILTER_INPUT_CLASS}
        >
          <option value="">All templates</option>
          {notificationTemplateOptions.map((template) => (
            <option key={template} value={template}>
              {template}
            </option>
          ))}
        </Input>
        <Input
          type="select"
          bsSize="sm"
          value={notificationStatusFilter}
          onChange={(e) => setNotificationStatusFilter(e.target.value)}
          className={STORE_DASHBOARD_FILTER_INPUT_CLASS}
        >
          <option value="">All statuses</option>
          {notificationStatusOptions.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </Input>
      </div>
      {notificationsLoading ? (
        <div className="py-4 text-center text-muted">
          <Spinner className="me-2" />
          Loading…
        </div>
      ) : notificationsError ? (
        <Alert color="danger" className="mb-0" fade={false}>
          {notificationsError}
        </Alert>
      ) : (
        <Table
          bordered
          hover
          responsive
          className="mb-0 store-sales-table"
        >
          <thead className="store-sales-table__head">
            <tr>
              <th
                role="button"
                onClick={() => handleNotificationsSort("name")}
              >
                Name {renderNotificationSortIcon("name")}
              </th>
              <th>Mobile</th>
              <th
                role="button"
                onClick={() => handleNotificationsSort("templateName")}
              >
                Template {renderNotificationSortIcon("templateName")}
              </th>
              <th>Status</th>
              <th
                role="button"
                onClick={() => handleNotificationsSort("createdAt")}
              >
                Sent At {renderNotificationSortIcon("createdAt")}
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredNotifications.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-muted text-center py-4">
                  No notifications found.
                </td>
              </tr>
            ) : (
              filteredNotifications.map((row) => (
                <tr key={row.id ?? `${row.name}-${row.createdAt}`}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <span>{row.name}</span>
                      <span
                        className={`store-recipient-pill store-recipient-pill--${row.recipientType}`}
                      >
                        {row.recipientType === "buyer"
                          ? "Buyer"
                          : row.recipientType === "dealer"
                          ? "Dealer"
                          : "Other"}
                      </span>
                    </div>
                  </td>
                  <td>{row.mobile}</td>
                  <td>{row.templateName}</td>
                  <td className="text-capitalize">{row.deliveryStatus}</td>
                  <td title={fmtHoverDateTime(row.createdAt)}>
                    {fmtRelativeTime(row.createdAt)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default StoreSalesDashboardNotificationsSection;
